/**
 * 앱 배포 버전 단일 출처 (SD-7923).
 *
 * Datadog RUM `version` 과 백엔드 호출 User-Agent 토큰 버전이 이 값을 공유한다
 * (배포 버전 = 관측 버전 = UA 버전 → 로그·대시보드 상관 용이).
 *
 * 메이저/마이너(APP_VERSION_BASE)는 *여기서 수동으로* 올린다(릴리스 시 1.0 → 1.1 등).
 * 패치 자리는 Jenkins BUILD_NUMBER(NEXT_PUBLIC_BUILD_NUMBER)가 배포마다 자동 증가.
 * 빌드번호 부재(로컬/미주입) 시 "0" → 로컬은 1.0.0.
 *
 * NEXT_PUBLIC_* 라 클라이언트(instrumentation-client)·서버(API 라우트) 번들 양쪽에
 * 빌드 시점 값으로 인라인된다.
 *
 * `||` 사용 주의: Dockerfile 의 `ENV NEXT_PUBLIC_BUILD_NUMBER=$ARG` 는 build-arg 미주입 시
 * undefined 가 아니라 빈 문자열("")로 인라인된다. `??` 면 ""을 통과시켜 "1.0." 가 되므로,
 * 빈 문자열도 "0" 으로 폴백되도록 `||` 를 쓴다.
 */
const APP_VERSION_BASE = "1.0";

export const APP_VERSION = `${APP_VERSION_BASE}.${
  process.env.NEXT_PUBLIC_BUILD_NUMBER || "0"
}`;
